import store from '~/store';
var state = store.state;
var DictService = /** @class */ (function () {
    function DictService() {
    }
    /**
     * 获取字典数据
     * @param codes
     */
    DictService.getDictData = function () {
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        var results = [];
        // 获取字典项
        keys.forEach(function (key) {
            var items = state.dictData[key];
            if (items && items.length) {
                results.push.apply(results, items);
            }
        });
        return results;
    };
    /**
     * 过滤器：获取字典名称
     * @param code 字典键值
     */
    DictService.getDictName = function (code, key) {
        var result = '';
        if (code && key) {
            var values = state.dictData[key];
            if (!values)
                return result;
            var find = values.find(function (x) { return x.code === code; }) || {};
            result = find.name;
        }
        return result;
    };
    /**
     * 格式化拼接的字典项名称
     * @param value 拼接的字典ID字符串
     * @param split 拼接符
     */
    DictService.getDictNameForAppendStr = function (value, split) {
        value = value || "";
        split = split || ",";
        var arr = value.split(split);
        return DictService.getDictData(arr).map(function (x) { return x.name; }).join(split);
    };
    return DictService;
}());
export { DictService };
